import axios from "@services/api/axios";

const endpoints = {
    getCargo: () => axios.get('/dicti/card/cargo'),
    getCargoDicties: () => axios.get('/dicti/card/cargo/put'),
};

export default endpoints;
